import React, { useEffect } from "react";
import { Button, Dropdown, Popup, Form } from "semantic-ui-react";

import FilterView from "./FilterView";

const FilterBox = ({ search, header, triggerUpdate }) => {
  useEffect(() => {
    //subscribe to filter updates and trigger an update
    const subscription = search.subscribe("filter.update", triggerUpdate);
    return () => {
      search.unsubscribe("filter.update", subscription);
    };
  });

  if (Object.keys(search.filters).length < 1) {
    return null;
  }

  return (
    <Form>
      {header}
      {Object.keys(search.filters).map(aFilter => (
        <Form.Field key={search.filters[aFilter].filterId}>
          <Popup
            trigger={
              <Button
                icon="remove"
                size="mini"
                compact
                onClick={() => {
                  search.addFilter([
                    {
                      filterId: search.filters[aFilter].filterId,
                      filterType: null
                    }
                  ]);
                  triggerUpdate();
                }}
              />
            }
            content="Remove this filter"
            size="mini"
          />

          <Dropdown
            inline
            defaultValue={search.filters[aFilter].filterType}
            options={[
              {
                text: "- On Hold -",
                value: "_"
              },
              { text: "Must have", value: "A" },
              { text: "Include", value: "O" },
              { text: "Exclude", value: "N" }
            ]}
            onChange={(event, data) => {
              search.addFilter([
                {
                  filterId: search.filters[aFilter].filterId,
                  filterType: data.value,
                  fieldName: search.filters[aFilter].fieldName,
                  fieldValue: search.filters[aFilter].fieldValue
                }
              ]);
              triggerUpdate();
            }}
          />
          <FilterView
            aFilter={search.filters[aFilter]}
            search={search}
            triggerUpdate={triggerUpdate}
          />
        </Form.Field>
      ))}
    </Form>
  );
};

export default FilterBox;
